import { render, staticRenderFns } from "./outras-despesas.vue?vue&type=template&id=1894b9c5&scoped=true&"
import script from "./outras-despesas.vue?vue&type=script&lang=js&"
export * from "./outras-despesas.vue?vue&type=script&lang=js&"
import style0 from "./outras-despesas.vue?vue&type=style&index=0&id=1894b9c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1894b9c5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VSpacer})
